const BigTile = () => {
  return (
    <div className="round-lg aspect-square w-full rounded-xl border border-gray-300 bg-white px-4 py-3"></div>
  );
};

export default BigTile;
